var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "thirdPage" },
    [
      _c(
        "van-dialog",
        {
          attrs: { "show-confirm-button": false },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            { staticClass: "wrap_box", on: { click: _vm.closeBefore } },
            [
              _c("div", { staticClass: "center" }, [
                _c("div", { staticClass: "title" }, [
                  _c("div", [_vm._v("Bank Verification Page")]),
                  _c("img", {
                    attrs: { src: require("@/assets/images/t_close.png") },
                    on: { click: _vm.close },
                  }),
                ]),
                _c("div", { staticClass: "contents" }, [
                  _c("iframe", {
                    key: _vm.currentKey,
                    staticClass: "iframeContents",
                    attrs: { src: _vm.iframeUrl, frameborder: "0" },
                  }),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("commonDialog", {
        attrs: { dialogData: _vm.dialogData },
        on: { confirmA: _vm.close, confirmB: _vm.dialogConfirmB },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }